// source: annotation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.Annotation', null, global);
goog.exportSymbol('proto.AnnotationData', null, global);
goog.exportSymbol('proto.AnnotationStyle', null, global);
goog.exportSymbol('proto.AnnotationTransform', null, global);
goog.exportSymbol('proto.AnnotationType', null, global);
goog.exportSymbol('proto.CreateAnnotationRequest', null, global);
goog.exportSymbol('proto.CreateAnnotationResponse', null, global);
goog.exportSymbol('proto.DeleteAnnotationRequest', null, global);
goog.exportSymbol('proto.DeleteAnnotationResponse', null, global);
goog.exportSymbol('proto.GeometryData', null, global);
goog.exportSymbol('proto.GetAnnotationsRequest', null, global);
goog.exportSymbol('proto.GetAnnotationsResponse', null, global);
goog.exportSymbol('proto.HyperlinkData', null, global);
goog.exportSymbol('proto.HyperlinkTargetType', null, global);
goog.exportSymbol('proto.Leader', null, global);
goog.exportSymbol('proto.LeaderAnchor', null, global);
goog.exportSymbol('proto.LeaderPoint', null, global);
goog.exportSymbol('proto.LeaderStyle', null, global);
goog.exportSymbol('proto.UpdateAnnotationRequest', null, global);
goog.exportSymbol('proto.UpdateAnnotationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.LeaderPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.LeaderPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.LeaderPoint.displayName = 'proto.LeaderPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.LeaderStyle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.LeaderStyle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.LeaderStyle.displayName = 'proto.LeaderStyle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Leader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Leader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Leader.displayName = 'proto.Leader';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AnnotationStyle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AnnotationStyle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AnnotationStyle.displayName = 'proto.AnnotationStyle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AnnotationTransform = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AnnotationTransform, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AnnotationTransform.displayName = 'proto.AnnotationTransform';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.HyperlinkData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.HyperlinkData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.HyperlinkData.displayName = 'proto.HyperlinkData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GeometryData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.GeometryData.repeatedFields_, null);
};
goog.inherits(proto.GeometryData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GeometryData.displayName = 'proto.GeometryData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.AnnotationData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.AnnotationData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.AnnotationData.displayName = 'proto.AnnotationData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Annotation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Annotation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Annotation.displayName = 'proto.Annotation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CreateAnnotationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CreateAnnotationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CreateAnnotationRequest.displayName = 'proto.CreateAnnotationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.CreateAnnotationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.CreateAnnotationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.CreateAnnotationResponse.displayName = 'proto.CreateAnnotationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetAnnotationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.GetAnnotationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetAnnotationsRequest.displayName = 'proto.GetAnnotationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.GetAnnotationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.GetAnnotationsResponse.repeatedFields_, null);
};
goog.inherits(proto.GetAnnotationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.GetAnnotationsResponse.displayName = 'proto.GetAnnotationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UpdateAnnotationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UpdateAnnotationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UpdateAnnotationRequest.displayName = 'proto.UpdateAnnotationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UpdateAnnotationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UpdateAnnotationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UpdateAnnotationResponse.displayName = 'proto.UpdateAnnotationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeleteAnnotationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeleteAnnotationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeleteAnnotationRequest.displayName = 'proto.DeleteAnnotationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DeleteAnnotationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DeleteAnnotationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.DeleteAnnotationResponse.displayName = 'proto.DeleteAnnotationResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.LeaderPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.LeaderPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.LeaderPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LeaderPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFieldWithDefault(msg, 1, ""),
y: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.LeaderPoint}
 */
proto.LeaderPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.LeaderPoint;
  return proto.LeaderPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.LeaderPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.LeaderPoint}
 */
proto.LeaderPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.LeaderPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.LeaderPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.LeaderPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LeaderPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getY();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string x = 1;
 * @return {string}
 */
proto.LeaderPoint.prototype.getX = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.LeaderPoint} returns this
 */
proto.LeaderPoint.prototype.setX = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string y = 2;
 * @return {string}
 */
proto.LeaderPoint.prototype.getY = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.LeaderPoint} returns this
 */
proto.LeaderPoint.prototype.setY = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.LeaderStyle.prototype.toObject = function(opt_includeInstance) {
  return proto.LeaderStyle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.LeaderStyle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LeaderStyle.toObject = function(includeInstance, msg) {
  var f, obj = {
stroke: jspb.Message.getFieldWithDefault(msg, 1, ""),
strokewidth: jspb.Message.getFieldWithDefault(msg, 2, ""),
strokedasharray: jspb.Message.getFieldWithDefault(msg, 3, ""),
opacity: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.LeaderStyle}
 */
proto.LeaderStyle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.LeaderStyle;
  return proto.LeaderStyle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.LeaderStyle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.LeaderStyle}
 */
proto.LeaderStyle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStroke(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrokewidth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrokedasharray(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpacity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.LeaderStyle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.LeaderStyle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.LeaderStyle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.LeaderStyle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStroke();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStrokewidth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStrokedasharray();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpacity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string stroke = 1;
 * @return {string}
 */
proto.LeaderStyle.prototype.getStroke = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.LeaderStyle} returns this
 */
proto.LeaderStyle.prototype.setStroke = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string strokeWidth = 2;
 * @return {string}
 */
proto.LeaderStyle.prototype.getStrokewidth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.LeaderStyle} returns this
 */
proto.LeaderStyle.prototype.setStrokewidth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string strokeDasharray = 3;
 * @return {string}
 */
proto.LeaderStyle.prototype.getStrokedasharray = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.LeaderStyle} returns this
 */
proto.LeaderStyle.prototype.setStrokedasharray = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string opacity = 4;
 * @return {string}
 */
proto.LeaderStyle.prototype.getOpacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.LeaderStyle} returns this
 */
proto.LeaderStyle.prototype.setOpacity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Leader.prototype.toObject = function(opt_includeInstance) {
  return proto.Leader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Leader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Leader.toObject = function(includeInstance, msg) {
  var f, obj = {
anchor: jspb.Message.getFieldWithDefault(msg, 1, 0),
pivot: (f = msg.getPivot()) && proto.LeaderPoint.toObject(includeInstance, f),
end: (f = msg.getEnd()) && proto.LeaderPoint.toObject(includeInstance, f),
showarrowhead: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
arrowheadsize: jspb.Message.getFieldWithDefault(msg, 5, ""),
style: (f = msg.getStyle()) && proto.LeaderStyle.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Leader}
 */
proto.Leader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Leader;
  return proto.Leader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Leader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Leader}
 */
proto.Leader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.LeaderAnchor} */ (reader.readEnum());
      msg.setAnchor(value);
      break;
    case 2:
      var value = new proto.LeaderPoint;
      reader.readMessage(value,proto.LeaderPoint.deserializeBinaryFromReader);
      msg.setPivot(value);
      break;
    case 3:
      var value = new proto.LeaderPoint;
      reader.readMessage(value,proto.LeaderPoint.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowarrowhead(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setArrowheadsize(value);
      break;
    case 6:
      var value = new proto.LeaderStyle;
      reader.readMessage(value,proto.LeaderStyle.deserializeBinaryFromReader);
      msg.setStyle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Leader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Leader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Leader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Leader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnchor();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPivot();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.LeaderPoint.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.LeaderPoint.serializeBinaryToWriter
    );
  }
  f = message.getShowarrowhead();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getArrowheadsize();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStyle();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.LeaderStyle.serializeBinaryToWriter
    );
  }
};


/**
 * optional LeaderAnchor anchor = 1;
 * @return {!proto.LeaderAnchor}
 */
proto.Leader.prototype.getAnchor = function() {
  return /** @type {!proto.LeaderAnchor} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.LeaderAnchor} value
 * @return {!proto.Leader} returns this
 */
proto.Leader.prototype.setAnchor = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional LeaderPoint pivot = 2;
 * @return {?proto.LeaderPoint}
 */
proto.Leader.prototype.getPivot = function() {
  return /** @type{?proto.LeaderPoint} */ (
    jspb.Message.getWrapperField(this, proto.LeaderPoint, 2));
};


/**
 * @param {?proto.LeaderPoint|undefined} value
 * @return {!proto.Leader} returns this
*/
proto.Leader.prototype.setPivot = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Leader} returns this
 */
proto.Leader.prototype.clearPivot = function() {
  return this.setPivot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Leader.prototype.hasPivot = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LeaderPoint end = 3;
 * @return {?proto.LeaderPoint}
 */
proto.Leader.prototype.getEnd = function() {
  return /** @type{?proto.LeaderPoint} */ (
    jspb.Message.getWrapperField(this, proto.LeaderPoint, 3));
};


/**
 * @param {?proto.LeaderPoint|undefined} value
 * @return {!proto.Leader} returns this
*/
proto.Leader.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Leader} returns this
 */
proto.Leader.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Leader.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool showArrowHead = 4;
 * @return {boolean}
 */
proto.Leader.prototype.getShowarrowhead = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Leader} returns this
 */
proto.Leader.prototype.setShowarrowhead = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string arrowHeadSize = 5;
 * @return {string}
 */
proto.Leader.prototype.getArrowheadsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Leader} returns this
 */
proto.Leader.prototype.setArrowheadsize = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional LeaderStyle style = 6;
 * @return {?proto.LeaderStyle}
 */
proto.Leader.prototype.getStyle = function() {
  return /** @type{?proto.LeaderStyle} */ (
    jspb.Message.getWrapperField(this, proto.LeaderStyle, 6));
};


/**
 * @param {?proto.LeaderStyle|undefined} value
 * @return {!proto.Leader} returns this
*/
proto.Leader.prototype.setStyle = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Leader} returns this
 */
proto.Leader.prototype.clearStyle = function() {
  return this.setStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Leader.prototype.hasStyle = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AnnotationStyle.prototype.toObject = function(opt_includeInstance) {
  return proto.AnnotationStyle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AnnotationStyle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AnnotationStyle.toObject = function(includeInstance, msg) {
  var f, obj = {
fill: jspb.Message.getFieldWithDefault(msg, 1, ""),
stroke: jspb.Message.getFieldWithDefault(msg, 2, ""),
strokewidth: jspb.Message.getFieldWithDefault(msg, 3, ""),
strokedasharray: jspb.Message.getFieldWithDefault(msg, 4, ""),
opacity: jspb.Message.getFieldWithDefault(msg, 5, ""),
fontsize: jspb.Message.getFieldWithDefault(msg, 6, ""),
fontfamily: jspb.Message.getFieldWithDefault(msg, 7, ""),
fontweight: jspb.Message.getFieldWithDefault(msg, 8, ""),
textanchor: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AnnotationStyle}
 */
proto.AnnotationStyle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AnnotationStyle;
  return proto.AnnotationStyle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AnnotationStyle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AnnotationStyle}
 */
proto.AnnotationStyle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFill(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStroke(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrokewidth(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrokedasharray(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpacity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontsize(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontfamily(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFontweight(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTextanchor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AnnotationStyle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AnnotationStyle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AnnotationStyle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AnnotationStyle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFill();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStroke();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStrokewidth();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStrokedasharray();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOpacity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFontsize();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFontfamily();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFontweight();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTextanchor();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string fill = 1;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getFill = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setFill = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string stroke = 2;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getStroke = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setStroke = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string strokeWidth = 3;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getStrokewidth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setStrokewidth = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string strokeDasharray = 4;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getStrokedasharray = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setStrokedasharray = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string opacity = 5;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getOpacity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setOpacity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string fontSize = 6;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getFontsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setFontsize = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string fontFamily = 7;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getFontfamily = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setFontfamily = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string fontWeight = 8;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getFontweight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setFontweight = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string textAnchor = 9;
 * @return {string}
 */
proto.AnnotationStyle.prototype.getTextanchor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationStyle} returns this
 */
proto.AnnotationStyle.prototype.setTextanchor = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AnnotationTransform.prototype.toObject = function(opt_includeInstance) {
  return proto.AnnotationTransform.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AnnotationTransform} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AnnotationTransform.toObject = function(includeInstance, msg) {
  var f, obj = {
rotation: jspb.Message.getFieldWithDefault(msg, 1, ""),
scalex: jspb.Message.getFieldWithDefault(msg, 2, ""),
scaley: jspb.Message.getFieldWithDefault(msg, 3, ""),
skewx: jspb.Message.getFieldWithDefault(msg, 4, ""),
skewy: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AnnotationTransform}
 */
proto.AnnotationTransform.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AnnotationTransform;
  return proto.AnnotationTransform.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AnnotationTransform} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AnnotationTransform}
 */
proto.AnnotationTransform.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRotation(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScalex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setScaley(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkewx(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkewy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AnnotationTransform.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AnnotationTransform.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AnnotationTransform} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AnnotationTransform.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRotation();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScalex();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScaley();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSkewx();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSkewy();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string rotation = 1;
 * @return {string}
 */
proto.AnnotationTransform.prototype.getRotation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationTransform} returns this
 */
proto.AnnotationTransform.prototype.setRotation = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string scaleX = 2;
 * @return {string}
 */
proto.AnnotationTransform.prototype.getScalex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationTransform} returns this
 */
proto.AnnotationTransform.prototype.setScalex = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string scaleY = 3;
 * @return {string}
 */
proto.AnnotationTransform.prototype.getScaley = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationTransform} returns this
 */
proto.AnnotationTransform.prototype.setScaley = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string skewX = 4;
 * @return {string}
 */
proto.AnnotationTransform.prototype.getSkewx = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationTransform} returns this
 */
proto.AnnotationTransform.prototype.setSkewx = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string skewY = 5;
 * @return {string}
 */
proto.AnnotationTransform.prototype.getSkewy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationTransform} returns this
 */
proto.AnnotationTransform.prototype.setSkewy = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.HyperlinkData.prototype.toObject = function(opt_includeInstance) {
  return proto.HyperlinkData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.HyperlinkData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.HyperlinkData.toObject = function(includeInstance, msg) {
  var f, obj = {
targettype: jspb.Message.getFieldWithDefault(msg, 1, 0),
targetobjectid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.HyperlinkData}
 */
proto.HyperlinkData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.HyperlinkData;
  return proto.HyperlinkData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.HyperlinkData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.HyperlinkData}
 */
proto.HyperlinkData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.HyperlinkTargetType} */ (reader.readEnum());
      msg.setTargettype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetobjectid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.HyperlinkData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.HyperlinkData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.HyperlinkData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.HyperlinkData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargettype();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTargetobjectid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional HyperlinkTargetType targetType = 1;
 * @return {!proto.HyperlinkTargetType}
 */
proto.HyperlinkData.prototype.getTargettype = function() {
  return /** @type {!proto.HyperlinkTargetType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.HyperlinkTargetType} value
 * @return {!proto.HyperlinkData} returns this
 */
proto.HyperlinkData.prototype.setTargettype = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string targetObjectId = 2;
 * @return {string}
 */
proto.HyperlinkData.prototype.getTargetobjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.HyperlinkData} returns this
 */
proto.HyperlinkData.prototype.setTargetobjectid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.GeometryData.repeatedFields_ = [20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GeometryData.prototype.toObject = function(opt_includeInstance) {
  return proto.GeometryData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GeometryData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GeometryData.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFieldWithDefault(msg, 1, ""),
y: jspb.Message.getFieldWithDefault(msg, 2, ""),
width: jspb.Message.getFieldWithDefault(msg, 3, ""),
height: jspb.Message.getFieldWithDefault(msg, 4, ""),
cx: jspb.Message.getFieldWithDefault(msg, 5, ""),
cy: jspb.Message.getFieldWithDefault(msg, 6, ""),
r: jspb.Message.getFieldWithDefault(msg, 7, ""),
rx: jspb.Message.getFieldWithDefault(msg, 8, ""),
ry: jspb.Message.getFieldWithDefault(msg, 9, ""),
x1: jspb.Message.getFieldWithDefault(msg, 10, ""),
y1: jspb.Message.getFieldWithDefault(msg, 11, ""),
x2: jspb.Message.getFieldWithDefault(msg, 12, ""),
y2: jspb.Message.getFieldWithDefault(msg, 13, ""),
points: jspb.Message.getFieldWithDefault(msg, 14, ""),
d: jspb.Message.getFieldWithDefault(msg, 15, ""),
text: jspb.Message.getFieldWithDefault(msg, 16, ""),
markerstart: jspb.Message.getFieldWithDefault(msg, 17, ""),
markerend: jspb.Message.getFieldWithDefault(msg, 18, ""),
hyperlinkdata: (f = msg.getHyperlinkdata()) && proto.HyperlinkData.toObject(includeInstance, f),
leadersList: jspb.Message.toObjectList(msg.getLeadersList(),
    proto.Leader.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GeometryData}
 */
proto.GeometryData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GeometryData;
  return proto.GeometryData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GeometryData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GeometryData}
 */
proto.GeometryData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWidth(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCx(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setR(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRx(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRy(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setX1(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setY1(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setX2(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setY2(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setPoints(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setD(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkerstart(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkerend(value);
      break;
    case 19:
      var value = new proto.HyperlinkData;
      reader.readMessage(value,proto.HyperlinkData.deserializeBinaryFromReader);
      msg.setHyperlinkdata(value);
      break;
    case 20:
      var value = new proto.Leader;
      reader.readMessage(value,proto.Leader.deserializeBinaryFromReader);
      msg.addLeaders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GeometryData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GeometryData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GeometryData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GeometryData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getY();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWidth();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCx();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getR();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRx();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRy();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getX1();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getY1();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getX2();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getY2();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPoints();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getD();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getMarkerstart();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMarkerend();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getHyperlinkdata();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.HyperlinkData.serializeBinaryToWriter
    );
  }
  f = message.getLeadersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      20,
      f,
      proto.Leader.serializeBinaryToWriter
    );
  }
};


/**
 * optional string x = 1;
 * @return {string}
 */
proto.GeometryData.prototype.getX = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setX = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string y = 2;
 * @return {string}
 */
proto.GeometryData.prototype.getY = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setY = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string width = 3;
 * @return {string}
 */
proto.GeometryData.prototype.getWidth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setWidth = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string height = 4;
 * @return {string}
 */
proto.GeometryData.prototype.getHeight = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setHeight = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string cx = 5;
 * @return {string}
 */
proto.GeometryData.prototype.getCx = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setCx = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string cy = 6;
 * @return {string}
 */
proto.GeometryData.prototype.getCy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setCy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string r = 7;
 * @return {string}
 */
proto.GeometryData.prototype.getR = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setR = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string rx = 8;
 * @return {string}
 */
proto.GeometryData.prototype.getRx = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setRx = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string ry = 9;
 * @return {string}
 */
proto.GeometryData.prototype.getRy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setRy = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string x1 = 10;
 * @return {string}
 */
proto.GeometryData.prototype.getX1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setX1 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string y1 = 11;
 * @return {string}
 */
proto.GeometryData.prototype.getY1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setY1 = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string x2 = 12;
 * @return {string}
 */
proto.GeometryData.prototype.getX2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setX2 = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string y2 = 13;
 * @return {string}
 */
proto.GeometryData.prototype.getY2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setY2 = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string points = 14;
 * @return {string}
 */
proto.GeometryData.prototype.getPoints = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setPoints = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string d = 15;
 * @return {string}
 */
proto.GeometryData.prototype.getD = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setD = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string text = 16;
 * @return {string}
 */
proto.GeometryData.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string markerStart = 17;
 * @return {string}
 */
proto.GeometryData.prototype.getMarkerstart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setMarkerstart = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string markerEnd = 18;
 * @return {string}
 */
proto.GeometryData.prototype.getMarkerend = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.setMarkerend = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional HyperlinkData hyperlinkData = 19;
 * @return {?proto.HyperlinkData}
 */
proto.GeometryData.prototype.getHyperlinkdata = function() {
  return /** @type{?proto.HyperlinkData} */ (
    jspb.Message.getWrapperField(this, proto.HyperlinkData, 19));
};


/**
 * @param {?proto.HyperlinkData|undefined} value
 * @return {!proto.GeometryData} returns this
*/
proto.GeometryData.prototype.setHyperlinkdata = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.clearHyperlinkdata = function() {
  return this.setHyperlinkdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.GeometryData.prototype.hasHyperlinkdata = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * repeated Leader leaders = 20;
 * @return {!Array<!proto.Leader>}
 */
proto.GeometryData.prototype.getLeadersList = function() {
  return /** @type{!Array<!proto.Leader>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Leader, 20));
};


/**
 * @param {!Array<!proto.Leader>} value
 * @return {!proto.GeometryData} returns this
*/
proto.GeometryData.prototype.setLeadersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 20, value);
};


/**
 * @param {!proto.Leader=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Leader}
 */
proto.GeometryData.prototype.addLeaders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.Leader, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GeometryData} returns this
 */
proto.GeometryData.prototype.clearLeadersList = function() {
  return this.setLeadersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.AnnotationData.prototype.toObject = function(opt_includeInstance) {
  return proto.AnnotationData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.AnnotationData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AnnotationData.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
x: jspb.Message.getFieldWithDefault(msg, 2, ""),
y: jspb.Message.getFieldWithDefault(msg, 3, ""),
text: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, 0),
geometry: (f = msg.getGeometry()) && proto.GeometryData.toObject(includeInstance, f),
style: (f = msg.getStyle()) && proto.AnnotationStyle.toObject(includeInstance, f),
transform: (f = msg.getTransform()) && proto.AnnotationTransform.toObject(includeInstance, f),
layerid: jspb.Message.getFieldWithDefault(msg, 9, ""),
locked: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
visible: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
groupid: jspb.Message.getFieldWithDefault(msg, 12, ""),
selectable: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
draggable: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
resizable: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
custompropertiesMap: (f = msg.getCustompropertiesMap()) ? f.toObject(includeInstance, undefined) : [],
isdimensional: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.AnnotationData}
 */
proto.AnnotationData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.AnnotationData;
  return proto.AnnotationData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.AnnotationData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.AnnotationData}
 */
proto.AnnotationData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setX(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setY(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 5:
      var value = /** @type {!proto.AnnotationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = new proto.GeometryData;
      reader.readMessage(value,proto.GeometryData.deserializeBinaryFromReader);
      msg.setGeometry(value);
      break;
    case 7:
      var value = new proto.AnnotationStyle;
      reader.readMessage(value,proto.AnnotationStyle.deserializeBinaryFromReader);
      msg.setStyle(value);
      break;
    case 8:
      var value = new proto.AnnotationTransform;
      reader.readMessage(value,proto.AnnotationTransform.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLayerid(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLocked(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelectable(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDraggable(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResizable(value);
      break;
    case 16:
      var value = msg.getCustompropertiesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsdimensional(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.AnnotationData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.AnnotationData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.AnnotationData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.AnnotationData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getX();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getY();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getGeometry();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.GeometryData.serializeBinaryToWriter
    );
  }
  f = message.getStyle();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.AnnotationStyle.serializeBinaryToWriter
    );
  }
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.AnnotationTransform.serializeBinaryToWriter
    );
  }
  f = message.getLayerid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLocked();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSelectable();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getDraggable();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getResizable();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getCustompropertiesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(16, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getIsdimensional();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.AnnotationData.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string x = 2;
 * @return {string}
 */
proto.AnnotationData.prototype.getX = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setX = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string y = 3;
 * @return {string}
 */
proto.AnnotationData.prototype.getY = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setY = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.AnnotationData.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional AnnotationType type = 5;
 * @return {!proto.AnnotationType}
 */
proto.AnnotationData.prototype.getType = function() {
  return /** @type {!proto.AnnotationType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.AnnotationType} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional GeometryData geometry = 6;
 * @return {?proto.GeometryData}
 */
proto.AnnotationData.prototype.getGeometry = function() {
  return /** @type{?proto.GeometryData} */ (
    jspb.Message.getWrapperField(this, proto.GeometryData, 6));
};


/**
 * @param {?proto.GeometryData|undefined} value
 * @return {!proto.AnnotationData} returns this
*/
proto.AnnotationData.prototype.setGeometry = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.clearGeometry = function() {
  return this.setGeometry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AnnotationData.prototype.hasGeometry = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional AnnotationStyle style = 7;
 * @return {?proto.AnnotationStyle}
 */
proto.AnnotationData.prototype.getStyle = function() {
  return /** @type{?proto.AnnotationStyle} */ (
    jspb.Message.getWrapperField(this, proto.AnnotationStyle, 7));
};


/**
 * @param {?proto.AnnotationStyle|undefined} value
 * @return {!proto.AnnotationData} returns this
*/
proto.AnnotationData.prototype.setStyle = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.clearStyle = function() {
  return this.setStyle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AnnotationData.prototype.hasStyle = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional AnnotationTransform transform = 8;
 * @return {?proto.AnnotationTransform}
 */
proto.AnnotationData.prototype.getTransform = function() {
  return /** @type{?proto.AnnotationTransform} */ (
    jspb.Message.getWrapperField(this, proto.AnnotationTransform, 8));
};


/**
 * @param {?proto.AnnotationTransform|undefined} value
 * @return {!proto.AnnotationData} returns this
*/
proto.AnnotationData.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.AnnotationData.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string layerId = 9;
 * @return {string}
 */
proto.AnnotationData.prototype.getLayerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setLayerid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool locked = 10;
 * @return {boolean}
 */
proto.AnnotationData.prototype.getLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool visible = 11;
 * @return {boolean}
 */
proto.AnnotationData.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string groupId = 12;
 * @return {string}
 */
proto.AnnotationData.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setGroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool selectable = 13;
 * @return {boolean}
 */
proto.AnnotationData.prototype.getSelectable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setSelectable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool draggable = 14;
 * @return {boolean}
 */
proto.AnnotationData.prototype.getDraggable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setDraggable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool resizable = 15;
 * @return {boolean}
 */
proto.AnnotationData.prototype.getResizable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setResizable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * map<string, string> customProperties = 16;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.AnnotationData.prototype.getCustompropertiesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 16, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.clearCustompropertiesMap = function() {
  this.getCustompropertiesMap().clear();
  return this;
};


/**
 * optional bool isDimensional = 17;
 * @return {boolean}
 */
proto.AnnotationData.prototype.getIsdimensional = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.AnnotationData} returns this
 */
proto.AnnotationData.prototype.setIsdimensional = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Annotation.prototype.toObject = function(opt_includeInstance) {
  return proto.Annotation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Annotation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Annotation.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
objectid: jspb.Message.getFieldWithDefault(msg, 2, ""),
annotationdata: (f = msg.getAnnotationdata()) && proto.AnnotationData.toObject(includeInstance, f),
createdbyuserid: jspb.Message.getFieldWithDefault(msg, 4, ""),
createdbyaccountid: jspb.Message.getFieldWithDefault(msg, 5, ""),
lastupdated: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Annotation}
 */
proto.Annotation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Annotation;
  return proto.Annotation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Annotation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Annotation}
 */
proto.Annotation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectid(value);
      break;
    case 3:
      var value = new proto.AnnotationData;
      reader.readMessage(value,proto.AnnotationData.deserializeBinaryFromReader);
      msg.setAnnotationdata(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedbyuserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedbyaccountid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastupdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Annotation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Annotation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Annotation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Annotation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObjectid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnnotationdata();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.AnnotationData.serializeBinaryToWriter
    );
  }
  f = message.getCreatedbyuserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedbyaccountid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLastupdated();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.Annotation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Annotation} returns this
 */
proto.Annotation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string objectId = 2;
 * @return {string}
 */
proto.Annotation.prototype.getObjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Annotation} returns this
 */
proto.Annotation.prototype.setObjectid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AnnotationData annotationData = 3;
 * @return {?proto.AnnotationData}
 */
proto.Annotation.prototype.getAnnotationdata = function() {
  return /** @type{?proto.AnnotationData} */ (
    jspb.Message.getWrapperField(this, proto.AnnotationData, 3));
};


/**
 * @param {?proto.AnnotationData|undefined} value
 * @return {!proto.Annotation} returns this
*/
proto.Annotation.prototype.setAnnotationdata = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Annotation} returns this
 */
proto.Annotation.prototype.clearAnnotationdata = function() {
  return this.setAnnotationdata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Annotation.prototype.hasAnnotationdata = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string createdByUserId = 4;
 * @return {string}
 */
proto.Annotation.prototype.getCreatedbyuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Annotation} returns this
 */
proto.Annotation.prototype.setCreatedbyuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string createdByAccountId = 5;
 * @return {string}
 */
proto.Annotation.prototype.getCreatedbyaccountid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Annotation} returns this
 */
proto.Annotation.prototype.setCreatedbyaccountid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string lastUpdated = 6;
 * @return {string}
 */
proto.Annotation.prototype.getLastupdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Annotation} returns this
 */
proto.Annotation.prototype.setLastupdated = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CreateAnnotationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.CreateAnnotationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CreateAnnotationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CreateAnnotationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
annotation: (f = msg.getAnnotation()) && proto.Annotation.toObject(includeInstance, f),
sessiontoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CreateAnnotationRequest}
 */
proto.CreateAnnotationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CreateAnnotationRequest;
  return proto.CreateAnnotationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CreateAnnotationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CreateAnnotationRequest}
 */
proto.CreateAnnotationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Annotation;
      reader.readMessage(value,proto.Annotation.deserializeBinaryFromReader);
      msg.setAnnotation(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CreateAnnotationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CreateAnnotationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CreateAnnotationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CreateAnnotationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnnotation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Annotation.serializeBinaryToWriter
    );
  }
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Annotation annotation = 1;
 * @return {?proto.Annotation}
 */
proto.CreateAnnotationRequest.prototype.getAnnotation = function() {
  return /** @type{?proto.Annotation} */ (
    jspb.Message.getWrapperField(this, proto.Annotation, 1));
};


/**
 * @param {?proto.Annotation|undefined} value
 * @return {!proto.CreateAnnotationRequest} returns this
*/
proto.CreateAnnotationRequest.prototype.setAnnotation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.CreateAnnotationRequest} returns this
 */
proto.CreateAnnotationRequest.prototype.clearAnnotation = function() {
  return this.setAnnotation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.CreateAnnotationRequest.prototype.hasAnnotation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string sessionToken = 2;
 * @return {string}
 */
proto.CreateAnnotationRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.CreateAnnotationRequest} returns this
 */
proto.CreateAnnotationRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.CreateAnnotationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.CreateAnnotationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CreateAnnotationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CreateAnnotationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, ""),
annotation: (f = msg.getAnnotation()) && proto.Annotation.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CreateAnnotationResponse}
 */
proto.CreateAnnotationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.CreateAnnotationResponse;
  return proto.CreateAnnotationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CreateAnnotationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CreateAnnotationResponse}
 */
proto.CreateAnnotationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = new proto.Annotation;
      reader.readMessage(value,proto.Annotation.deserializeBinaryFromReader);
      msg.setAnnotation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.CreateAnnotationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.CreateAnnotationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CreateAnnotationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.CreateAnnotationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnnotation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Annotation.serializeBinaryToWriter
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.CreateAnnotationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.CreateAnnotationResponse} returns this
 */
proto.CreateAnnotationResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Annotation annotation = 2;
 * @return {?proto.Annotation}
 */
proto.CreateAnnotationResponse.prototype.getAnnotation = function() {
  return /** @type{?proto.Annotation} */ (
    jspb.Message.getWrapperField(this, proto.Annotation, 2));
};


/**
 * @param {?proto.Annotation|undefined} value
 * @return {!proto.CreateAnnotationResponse} returns this
*/
proto.CreateAnnotationResponse.prototype.setAnnotation = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.CreateAnnotationResponse} returns this
 */
proto.CreateAnnotationResponse.prototype.clearAnnotation = function() {
  return this.setAnnotation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.CreateAnnotationResponse.prototype.hasAnnotation = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetAnnotationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.GetAnnotationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetAnnotationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetAnnotationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
objectid: jspb.Message.getFieldWithDefault(msg, 1, ""),
sessiontoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetAnnotationsRequest}
 */
proto.GetAnnotationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetAnnotationsRequest;
  return proto.GetAnnotationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetAnnotationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetAnnotationsRequest}
 */
proto.GetAnnotationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setObjectid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetAnnotationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetAnnotationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetAnnotationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetAnnotationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObjectid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string objectId = 1;
 * @return {string}
 */
proto.GetAnnotationsRequest.prototype.getObjectid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetAnnotationsRequest} returns this
 */
proto.GetAnnotationsRequest.prototype.setObjectid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sessionToken = 2;
 * @return {string}
 */
proto.GetAnnotationsRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.GetAnnotationsRequest} returns this
 */
proto.GetAnnotationsRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.GetAnnotationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.GetAnnotationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.GetAnnotationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetAnnotationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetAnnotationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
annotationsList: jspb.Message.toObjectList(msg.getAnnotationsList(),
    proto.Annotation.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetAnnotationsResponse}
 */
proto.GetAnnotationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.GetAnnotationsResponse;
  return proto.GetAnnotationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetAnnotationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetAnnotationsResponse}
 */
proto.GetAnnotationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Annotation;
      reader.readMessage(value,proto.Annotation.deserializeBinaryFromReader);
      msg.addAnnotations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.GetAnnotationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.GetAnnotationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetAnnotationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.GetAnnotationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnnotationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Annotation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Annotation annotations = 1;
 * @return {!Array<!proto.Annotation>}
 */
proto.GetAnnotationsResponse.prototype.getAnnotationsList = function() {
  return /** @type{!Array<!proto.Annotation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Annotation, 1));
};


/**
 * @param {!Array<!proto.Annotation>} value
 * @return {!proto.GetAnnotationsResponse} returns this
*/
proto.GetAnnotationsResponse.prototype.setAnnotationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Annotation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Annotation}
 */
proto.GetAnnotationsResponse.prototype.addAnnotations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Annotation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetAnnotationsResponse} returns this
 */
proto.GetAnnotationsResponse.prototype.clearAnnotationsList = function() {
  return this.setAnnotationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UpdateAnnotationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UpdateAnnotationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UpdateAnnotationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateAnnotationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
annotation: (f = msg.getAnnotation()) && proto.Annotation.toObject(includeInstance, f),
sessiontoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UpdateAnnotationRequest}
 */
proto.UpdateAnnotationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UpdateAnnotationRequest;
  return proto.UpdateAnnotationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UpdateAnnotationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UpdateAnnotationRequest}
 */
proto.UpdateAnnotationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Annotation;
      reader.readMessage(value,proto.Annotation.deserializeBinaryFromReader);
      msg.setAnnotation(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UpdateAnnotationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UpdateAnnotationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UpdateAnnotationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateAnnotationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnnotation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Annotation.serializeBinaryToWriter
    );
  }
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Annotation annotation = 1;
 * @return {?proto.Annotation}
 */
proto.UpdateAnnotationRequest.prototype.getAnnotation = function() {
  return /** @type{?proto.Annotation} */ (
    jspb.Message.getWrapperField(this, proto.Annotation, 1));
};


/**
 * @param {?proto.Annotation|undefined} value
 * @return {!proto.UpdateAnnotationRequest} returns this
*/
proto.UpdateAnnotationRequest.prototype.setAnnotation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.UpdateAnnotationRequest} returns this
 */
proto.UpdateAnnotationRequest.prototype.clearAnnotation = function() {
  return this.setAnnotation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.UpdateAnnotationRequest.prototype.hasAnnotation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string sessionToken = 2;
 * @return {string}
 */
proto.UpdateAnnotationRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.UpdateAnnotationRequest} returns this
 */
proto.UpdateAnnotationRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UpdateAnnotationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UpdateAnnotationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UpdateAnnotationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateAnnotationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UpdateAnnotationResponse}
 */
proto.UpdateAnnotationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UpdateAnnotationResponse;
  return proto.UpdateAnnotationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UpdateAnnotationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UpdateAnnotationResponse}
 */
proto.UpdateAnnotationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UpdateAnnotationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UpdateAnnotationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UpdateAnnotationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UpdateAnnotationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.UpdateAnnotationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.UpdateAnnotationResponse} returns this
 */
proto.UpdateAnnotationResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeleteAnnotationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.DeleteAnnotationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeleteAnnotationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteAnnotationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
sessiontoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeleteAnnotationRequest}
 */
proto.DeleteAnnotationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeleteAnnotationRequest;
  return proto.DeleteAnnotationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeleteAnnotationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeleteAnnotationRequest}
 */
proto.DeleteAnnotationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessiontoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeleteAnnotationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeleteAnnotationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeleteAnnotationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteAnnotationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessiontoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.DeleteAnnotationRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeleteAnnotationRequest} returns this
 */
proto.DeleteAnnotationRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sessionToken = 2;
 * @return {string}
 */
proto.DeleteAnnotationRequest.prototype.getSessiontoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeleteAnnotationRequest} returns this
 */
proto.DeleteAnnotationRequest.prototype.setSessiontoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DeleteAnnotationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.DeleteAnnotationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DeleteAnnotationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteAnnotationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DeleteAnnotationResponse}
 */
proto.DeleteAnnotationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DeleteAnnotationResponse;
  return proto.DeleteAnnotationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DeleteAnnotationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DeleteAnnotationResponse}
 */
proto.DeleteAnnotationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DeleteAnnotationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DeleteAnnotationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DeleteAnnotationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DeleteAnnotationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.DeleteAnnotationResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.DeleteAnnotationResponse} returns this
 */
proto.DeleteAnnotationResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.AnnotationType = {
  TEXT: 0,
  RECTANGLE: 1,
  CIRCLE: 2,
  ELLIPSE: 3,
  LINE: 4,
  POLYLINE: 5,
  POLYGON: 6,
  PATH: 7,
  HIGHLIGHTER: 8,
  ARROW: 9,
  FREEHAND: 10,
  HYPERLINK: 11
};

/**
 * @enum {number}
 */
proto.LeaderAnchor = {
  LEADER_ANCHOR_UNSPECIFIED: 0,
  NW: 1,
  N: 2,
  NE: 3,
  E: 4,
  SE: 5,
  S: 6,
  SW: 7,
  W: 8,
  C: 9
};

/**
 * @enum {number}
 */
proto.HyperlinkTargetType = {
  OBJECT: 0
};

goog.object.extend(exports, proto);
